import type { FutureSavingsPlannerConstants } from './types';

export const futureSavingsPlannerConstants = {
  initialDeposit: {
    min: 50,
    max: 50_000,
    default: 1_500,
    step: 50,
  },
  monthlyPayment: {
    min: 20,
    max: 2_000,
    default: 200,
    step: 10,
  },
} satisfies FutureSavingsPlannerConstants;

export const ANNUAL_RATES = {
  CAUTION: {
    min: 0.038,
    median: 0.056,
    max: 0.066,
  },
  BALANCED: {
    min: 0.045,
    median: 0.075,
    max: 0.095,
  },
  DYNAMISM: {
    min: 0.036,
    median: 0.076,
    max: 0.106,
  },
  BOLDNESS: {
    min: 0.048,
    median: 0.098,
    max: 0.118,
  },
};

export type RiskProfile = keyof typeof ANNUAL_RATES;

export type AnnualRate = (typeof ANNUAL_RATES)[RiskProfile];

export const riskProfiles = [
  'CAUTION',
  'BALANCED',
  'DYNAMISM',
  'BOLDNESS',
] as const satisfies RiskProfile[];
